<template>
  <div>
    <h1>ChallengeAndLeagueSelectorTest</h1>
    <h1>
      Test
      <ChallengeAndLeagueSelector v-model="selectedLeague"
                                  class="d-inline-flex"/>
    </h1>
    <p>Some text for testing</p>
  </div>
</template>

<script>
import ChallengeAndLeagueSelector from "@/components/league/ChallengeAndLeagueSelector";

export default {
  data() {
    return {
      selectedLeague: null,
    }
  },
  components: {
    ChallengeAndLeagueSelector
  }
}
</script>